import { render, staticRenderFns } from "./areaManagement.vue?vue&type=template&id=7619071c&scoped=true"
import script from "./areaManagement.vue?vue&type=script&lang=js"
export * from "./areaManagement.vue?vue&type=script&lang=js"
import style0 from "./areaManagement.vue?vue&type=style&index=0&id=7619071c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7619071c",
  null
  
)

export default component.exports